import React from "react";
import classNames from 'classnames';
import styled from "styled-components";

import { above, below } from '../style/functions';
import Col from './col';



const ImageTextSplit = ({ alt, background, color, children, image, position }) => {
  return (
    <ImageTextSplitWrapper className={classNames({ wrap: true, [position]: true })}>
      <Col className="split-image" fit>
        <img src={image} alt={alt} />
      </Col>
      <Col className="split-content" style={{ backgroundColor: background, color }}>
        <ContentWrapper>
          {children}
        </ContentWrapper>
      </Col>
    </ImageTextSplitWrapper>
  )
}

const ImageTextSplitWrapper = styled.section`
  align-items: stretch;
  display: flex;
  justify-content: stretch;
  position: relative;
  text-align: center;
  flex-wrap: wrap;

  cite {
    font-style: italic;
    opacity: 0.5;
    text-transform: upper;
    font-size: 0.8rem;
    margin-top: 1rem;
  }

  .col {
    min-width: 100%;
  }

  ${above.tablet`
    .col {
      min-width: 0;
    }

    &.right .split-image {
      order: 2;
    }
  `}

  .split-content {
    display: flex;
    align-items: center;
    justify-content: stretch;
    padding: 8rem 0;
  }

  ${below.tablet`
    .split-content {
      padding: 8rem 2rem;

      > * {
        max-width: 36rem;
        margin: 0 auto;
      }
    }
  `}

  ${below.mobile`
    .split-content {
      padding: 4rem 1rem;
    }
  `}

  > .col {
    flex: 1 1 0;
  }
`

const ContentWrapper = styled.div`
  margin: 0 4rem;
  flex: 1 0;

  ${below.tablet`
    margin: 0 2rem;
  `}

  > hr {
    max-width: 20em;
  }

  > * {
    max-width: 40em;
    margin-left: auto;
    margin-right: auto;
  }
`



ImageTextSplit.defaultProps = {
  alt: "",
  background: "#FFF",
  color: "inherit"
}



export default ImageTextSplit
